import { type Image, type Maybe, type Movie, type Tv } from '@tmdb-graphql-api/schema/types';
import { BackdropSize, ImageSize } from '../../../enums/imageSizes.ts';
import { buildImagePath } from '../../../helpers/buildImagePath.ts';
import { type Config } from '../../../types.ts';

export type MovieBackdropsData = {
  movie: Pick<Movie, 'backdrops'>;
};

export type TvBackdropsData = {
  tv: Pick<Tv, 'backdrops'>;
};

const format = (backdrops: Maybe<Image>[], config: Config) =>
  backdrops.reduce((acc: string[], backdrop) => {
    if (!backdrop) {
      return acc;
    }

    const imagePath = buildImagePath(backdrop.filePath, ImageSize.Backdrop, BackdropSize.LG, config.images);
    acc.push(imagePath);
    return acc;
  }, []);

export const formatBackdrops = (data: MovieBackdropsData | TvBackdropsData | null | undefined, config: Config) => {
  if (!data) {
    return [];
  }

  if ('movie' in data) {
    return format(data.movie.backdrops ?? [], config);
  }

  return format(data.tv.backdrops ?? [], config);
};
